module.exports = __webpack_public_path__ + "img/infibo-faq-screenshot-en.ee284bd6.png";